export const oktaConfig = {
    // issuer: "https://dev-03225501.okta.com/oauth2/default",
    // Working
    // issuer: "https://dentsuaegis-test.okta-emea.com/oauth2/default",
    // DIP
    issuer: "https://myapps-hybrid.dentsu.com/oauth2/default",
    // clientId: '0oakfmxqwzhtyTXYH5d7',
    // Working
    // clientId: '0oagn3iu2gS3fXxJC0i7',
    // DIP
    clientId: '0oapbr8xiee23lMCZ417',
    redirectUri: window.location.origin + '/login/callback',
    // redirectUri: 'http://localhost:3000/login/callback',
    scopes: ['openid', 'profile', 'email','offline_access'],
    // pkce: true,
    // TODO for auto refresh token
    // tokenManager: {
    //   autoRenew: true, //  Enables automatic token renewal
    //   // secure: true,    //  Stores tokens securely (https only)
    // },
  };

//   OKTA_AUTH = {
//     "ORG_URL": "https://dev-03225501.okta.com",
//     "ISSUER": "https://dev-03225501.okta.com/oauth2/default",
//     "CLIENT_ID": "0oakcs5siqMthwX3V5d7",
//     "CLIENT_SECRET": "98Y-xxGXnMCDDXWTtqqv8XPcywJuCWvhDQVb_SL9SXIMg4sb9rKihHwy9vThsSWZ",
//     "SCOPES": "openid profile email offline_access", # this is the default and can be omitted
//     "REDIRECT_URI": "http://localhost:8000/accounts/oauth2/callback/",
//     "LOGIN_REDIRECT_URL": "/", # default
//     "CACHE_PREFIX": "okta", # default
//     "CACHE_ALIAS": "default", # default
//     "PUBLIC_NAMED_URLS": (), # default
//     "PUBLIC_URLS": (), # default
//     "USE_USERNAME": False, # default
// }